export const BE_SUBJECTS_VALUES = {
  1: "english-arts-reading",
  2: "english-language-learner",
  3: "foreign-language",
  4: "general-elementary",
  5: "math",
  6: "science",
  7: "social-studies",
  8: "special-education",
  9: "other",
};

export const FE_SUBJECTS_VALUES = {
  1: "English / language arts / reading",
  2: "English language learner",
  3: "Foreign language",
  4: "General elementary",
  5: "Math",
  6: "Science",
  7: "Social studies / social science",
  8: "Special education",
  9: "Other",
};

export const FE_SUBJECTS_IDS = {
  "english-arts-reading": 1,
  "english-language-learner": 2,
  "foreign-language": 3,
  "general-elementary": 4,
  math: 5,
  science: 6,
  "social-studies": 7,
  "special-education": 8,
  other: 9,
};

const SUBJECTS = [
  {
    id: 1,
    name: "English / language arts / reading",
  },
  {
    id: 2,
    name: "English language learner",
  },
  {
    id: 3,
    name: "Foreign language",
  },
  {
    id: 4,
    name: "General elementary",
  },
  {
    id: 5,
    name: "Math",
  },
  {
    id: 6,
    name: "Science",
  },
  {
    id: 7,
    name: "Social studies / social science",
  },
  {
    id: 8,
    name: "Special education",
  },
  {
    id: 9,
    name: "Other",
  },
];

export default SUBJECTS;
